import { Api } from "./api"

const apiSauce = new Api();
apiSauce.setUp();


export default apiSauce
